'use client';

import dynamic from 'next/dynamic';

/**
 * Chart.js를 동적 import하여 대시보드 진입 시점에만 번들 로드
 */
const Chart = dynamic(
  () =>
    import('@/shared/lib/chart/registerCharts').then(() =>
      import('react-chartjs-2').then((m) => ({ default: m.Chart }))
    ),
  { ssr: false }
);

interface DashboardChartProps {
  type: 'funnel' | 'line' | 'bar';
  data: object;
  options: object;
}

export function DashboardChart({ type, data, options }: DashboardChartProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Chart type={type} data={data as any} options={options as any} />;
}
